/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Log/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import FromPart from './FromPart/index'
import React from 'react'
import ToPart from './ToPart/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Log({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Activities/Content/Activity/ActivityType/Log"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let activityTextpartsActorValueData = fromData.useDataValue({ viewPath,
context: 'activity',
path: 'textParts.actor',
})
let constantData = '‎'
let aggregateData = fromAggregate.join(activityTextpartsActorValueData, constantData)
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let activityTextpartsVerbValueData = fromData.useDataValue({ viewPath,
context: 'activity',
path: 'textParts.verb',
})
let constantData1 = 'the'
let activityTextpartsTargetValueData = fromData.useDataValue({ viewPath,
context: 'activity',
path: 'textParts.target',
})
let constantData2 = '‎'
let aggregateData1 = fromAggregate.join(activityTextpartsVerbValueData, constantData1, activityTextpartsTargetValueData, constantData2)
let activityTextpartsFromValueData = fromData.useDataValue({ viewPath,
context: 'activity',
path: 'textParts.from',
})
let activityTextpartsToValueData = fromData.useDataValue({ viewPath,
context: 'activity',
path: 'textParts.to',
})
let constantData3 = 'on'
let constantData4 = '‎'
let aggregateData2 = fromAggregate.join(constantData3, constantData4)
let activityTextpartsOnValueData = fromData.useDataValue({ viewPath,
context: 'activity',
path: 'textParts.on',
})
let constantData5 = '.'
let aggregateData3 = fromAggregate.joinNoSpace(activityTextpartsOnValueData, constantData5)
  return (<React.Fragment
>
<div
  data-testid="Log.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-kzp': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 display="inline"
 weight="medium"
 fontSize={dtTypographyFontsizeM}
 data="activity.textParts.actor"
 data="'‎'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 display="inline"
 fontSize={dtTypographyFontsizeM}
 data="activity.textParts.verb"
 data="'the'"
 data="activity.textParts.target"
 data="'‎'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData1}
/>
<fromFlow.When is={activityTextpartsFromValueData}>
<FromPart
  viewPath={`${viewPath}/FromPart`}
 data="activity.textParts.from"
/>
</fromFlow.When>
<fromFlow.When is={activityTextpartsToValueData}>
<ToPart
  viewPath={`${viewPath}/ToPart`}
 data="activity.textParts.to"
/>
</fromFlow.When>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 display="inline"
 fontSize={dtTypographyFontsizeM}
 data="'on'"
 data="'‎'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData2}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 display="inline"
 fontSize={dtTypographyFontsizeM}
 data="activity.textParts.on"
 data="'.'"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData3}
/>
</div>
{children}
</React.Fragment>)
}